import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { fetchActiveLeaderboards } from 'actions/leaderboard';
import DefaultLayout from 'layouts/default';
import { useContext, useEffect, useState } from 'react';
import './index.css';
import LeaderboardContext from 'contexts/leaderboard';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import { getToken } from 'actions/auth';
type ChallengesProps = {};
const Challenges = ({}: ChallengesProps) => {
  const { leaderboards, setLeaderboards } = useContext(LeaderboardContext);
  const [fetched, setFetched] = useState(false);
  useEffect(() => {
    fetchActiveLeaderboards().then((data) => {
      let newleaderboards = leaderboards;
      data.forEach((d: any) => {
        newleaderboards[d.slug] = d;
      });
      setLeaderboards(newleaderboards);
      setFetched(true);
    });
  }, []);
  if (!fetched || !leaderboards) {
    return (
      <DefaultLayout>
        <Loading text="Loading Challenges" />
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout>
      <div className="Challenges">
        <Typography variant="h3">Ongoing Challenges</Typography>
        <br />
        {Object.values(leaderboards)
          .sort()
          .map((leaderboard) => {
            return (
              <Card
                elevation={3}
                className={
                  'leaderboard-card ' + (leaderboard.hidden ? 'hidden' : '')
                }
                key={leaderboard.id}
              >
                <Link to={`/challenges/${leaderboard.slug}`}>
                  <CardActionArea>
                    <CardContent>
                      <Typography variant="h4">{leaderboard.name}</Typography>
                      <Typography variant="body1">
                        {leaderboard.description}
                      </Typography>
                      {leaderboard.hidden && (
                        <Typography variant="body2">
                          (hidden from public)
                        </Typography>
                      )}
                    </CardContent>
                  </CardActionArea>
                </Link>
              </Card>
            );
          })}
      </div>
    </DefaultLayout>
  );
};

export default Challenges;
